import HTTP from '../utils/HTTP';

class SendSMSService {
    fetchSms = () => {
        return HTTP.get('/admin/sms')
    };
    sendSms = (data) => {
        return HTTP.post('/admin/sms/add', data)
    };
    deleteSms = (id) => {
        return HTTP.delete(`/admin/sms/delete/${id}`)
    };
    
}

export default new SendSMSService();
